exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".hamburger[data-v-28a49a45]{display:inline-block;cursor:pointer;width:20px;height:20px;transform:rotate(0deg);transition:.38s;transform-origin:50% 50%;vertical-align:middle}.hamburger.is-active[data-v-28a49a45]{transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28a49a45","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/Hamburger.vue
// module id = 1151
// module chunks = 0